import React, {Component} from 'react'

class Help003 extends Component {
  constructor (props) {
    super(props)
    document.querySelector("meta[name='viewport']").setAttribute('content', 'width=1158px,shrink-to-fit=yes')
  }
  render () {
    return (
      <div className='container-fluid'>
        <div className='row-fluid'>
          <div className='span1' />
          <div className='span14 help-area'>
            <div className='page-header'>
              <h2><i className='icon-question-sign icon-large' />保存した見積書をコピーして雛型を作成し保存する</h2>
            </div>{/* ./page-header */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[3-1]</span>画面上部のメニューの中の「再利用」(図3-1 参照)を押してください。</legend>
              <figcaption>図3-1</figcaption>
              <ul>
                <li><img alt='' src='/help/help_3-1.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[3-2]</span>画面の中の「雛型を新規作成」ボタン(図3-2 参照)を押してください。</legend>
              <figcaption>図3-2</figcaption>
              <ul>
                <li><img alt='' src='/help/help_3-2.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[3-3]</span>「雛型カテゴリー」を選択し、「雛型の名称」を入力し「保存」ボタンを押してください。(図3-3 参照)</legend>
              <figcaption>図3-3</figcaption>
              <ul>
                <li><img alt='' src='/help/help_3-3.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[3-4]</span>メッセージが表示されるので「OK」ボタンを押してください。(図3-4 参照)</legend>
              <figcaption>図3-4</figcaption>
              <ul>
                <li><img alt='' src='/help/help_3-4.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[3-5]</span>新しく雛型が作成されました。<br />必要事項を編集し、最後の「この雛型の内容を保存する」ボタンをクリックしてください。(図3-5 参照)</legend>
              <figcaption>図3-5</figcaption>
              <ul>
                <li><img alt='' src='/help/help_3-5.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
          </div>{/* ./help-area */}
        </div>
      </div>
    )
  }
}

export default Help003



// WEBPACK FOOTER //
// ./src/help/Help003.js